import getters from '@/store/modules/home/getters';
import mutations from '@/store/modules/home/mutations';
import actions from '@/store/modules/home/actions';

export const state = {
  bannerList: [],
  popupList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
